module.exports = __webpack_public_path__ + "img/broncos-plus.7ec78c9c.png";